function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7308c7f4\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader!stylus-loader!../../stylus/components/_input-groups.styl")
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7308c7f4\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader!stylus-loader!../../stylus/components/_selection-controls.styl")
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7308c7f4\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader!stylus-loader!../../stylus/components/_switch.styl")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VSwitch.vue"
/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VSwitch/VSwitch.vue
// module id = 221
// module chunks = 0